import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { useAppAccess } from "@/hooks/useAppAccess";
import { isMarketingOnlyUser } from "@/lib/appAccess";
import { PageLoader } from "@/components/ui/Loader";
import { ROUTES } from "@/config/constants";
import { FABChamados } from "@/components/Chamados/FABChamados";

/**
 * Protege rotas autenticadas.
 * Enquanto a sessão é verificada, exibe loading.
 * Se não autenticado, redireciona para /login preservando a URL de origem.
 */
export function PrivateRoute() {
  const { isAuthenticated, loading, user } = useAuth();
  const { can } = useAppAccess();
  const location = useLocation();
  const marketingOnly = isMarketingOnlyUser(can, {
    locacoesOperador: user?.locacoesOperador,
    role: user?.role,
  });

  if (loading) return <PageLoader label="Verificando sessão..." />;

  if (!isAuthenticated) {
    return <Navigate to={ROUTES.LOGIN} state={{ from: location }} replace />;
  }

  return (
    <>
      <Outlet />
      {!marketingOnly && <FABChamados />}
    </>
  );
}
